import PropTypes from 'prop-types';

export const OERightTopBarEntryTypes = {
    targetMenu:                             'target_menu'
};

export const OERightTopBarPropTypes = {
    config: PropTypes.shape({
        enabled: PropTypes.bool,
        fullscreenBtn: PropTypes.bool,
        entries: PropTypes.arrayOf(PropTypes.shape({
            type: PropTypes.oneOf([OERightTopBarEntryTypes.targetMenu]),
            src: PropTypes.string
        }))
    })
};

export const OERightTopBarConfigFactory = {
    buildStdConfig()    {
        return {
            enabled: true,
            fullscreenBtn: true,
            entries: [
                {type: OERightTopBarEntryTypes.targetMenu}
            ]
        };
    }
};